import React from 'react';
import { ContainerProps } from '@mui/material/Container';
import { RaisinContainer } from '@raisin/components-lib';
import { components } from 'utils/componentsList';

export type LayoutContainerProps = {
  reference: ({ _content_type_uid: string; uid: string } & Record<string | symbol, unknown>)[];
} & ContainerProps;

export const ContentBlock = ({ componentName, componentData }) => {
  const Component = components[componentName];
  if (!Component) {
    return <div data-testid={`${componentName}Invalid`}>Unknown content type: {componentName}</div>;
  }

  return <Component {...componentData} isWrappedByLayoutContainer />;
};

export const LayoutContainer = ({ reference, ...props }: LayoutContainerProps) => (
  <RaisinContainer {...props}>
    {reference.map((component) => (
      <ContentBlock
        key={component.uid}
        componentName={component._content_type_uid}
        componentData={component}
      />
    ))}
  </RaisinContainer>
);
export default LayoutContainer;
